import Gallery from '../components/Gallery';

const HoldingPage = () => (
  <div className="holding fs pabs">
    <div className="fs txt-c holding-info pabs padx4">
      <h2>Scarlet Shillingford</h2>
      <h3 className="">Website coming soon</h3>
      <p className="contact"><a href="mailto:hello@scarletshillingford.com"></a></p>
    </div>
    <Gallery />
  </div>
)

export default HoldingPage



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/HoldingPage.js